// extracted by mini-css-extract-plugin
export default {"root":"BooleanFilter_root__JUTC6","input":"BooleanFilter_input__LU2I7","label":"BooleanFilter_label__c64cj"};